import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import styled from 'styled-components';
import { UserNameCell } from '../user-name-cell';

const Wrapper = styled.div<{ isManagerApproval: boolean }>`
  padding-left: ${({ isManagerApproval }) =>
    !isManagerApproval && 'var(--spacing-09)'};
  width: 100%;
`;

type TeamMemberParamtypes = {
  onUserSelection: (userId: number) => void;
  isManagerApproval: boolean;
};

export const TeamMemberRenderer = (
  params: ICellRendererParams & TeamMemberParamtypes,
) => {
  const { value, onUserSelection, isManagerApproval } = params;

  return (
    <Wrapper isManagerApproval={isManagerApproval}>
      <UserNameCell
        user={value.user}
        onUserSelection={onUserSelection}
        projectId={value.projectId}
        isManagerApproval={isManagerApproval}
      />
    </Wrapper>
  );
};
